/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-05-23",
    versionChannel: "nightly",
    buildDate: "2023-05-23T00:20:19.067Z",
    commitHash: "fe4475d5539bb50581231494f92f5108e47249e4",
};
